import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';
import { UploadType } from '../../utils/strivers_enums';
import {
  POLLING_INTERVAL,
  POLLING_TIMEOUT,
  STREAMING_STATUS,
} from '../../core/constants';
import { updateSetsVideo } from '../ProgramForm';
import { getUpdatedWelcomeVideo } from '../WelcomeVideo';

// ACTION CREATORS
export const addToQueue = (item) => ({ type: ACTION.ADD_TO_QUEUE, item });
export const cancelPolling = (item) => ({ type: ACTION.CANCEL_POLLING, item });
export const pollingComplete = (item) => ({ type: ACTION.POLLING_COMPLETE, item });
export const pollingTimeout = (item) => ({ type: ACTION.POLLING_TIMEOUT, item });

export const startPolling = (item) => (dispatch) => {
  dispatch(addToQueue(item));
  const startTime = +new Date();
  const intervalId = setInterval(() => {

    let apiMethod;
    switch (item.uploadType) {
      case UploadType.EXERCISE_VIDEOS:
        apiMethod = 'getExerciseVideo';
        break;
      case UploadType.OVERVIEW_VIDEOS:
        apiMethod = 'getOverviewVideo';
        break;
      case UploadType.WELCOME_VIDEO:
        apiMethod = 'getExerciseVideo';
        break;
      default:
        return;
    }

    apiService[apiMethod](item.videoId, item)
      .then(response => {
        // if this id is complete, dispatch pollingComplete for the item
        if (response.streaming_status === STREAMING_STATUS.COMPLETE) {
          const itemUpdate = {
            thumbnail: response.thumbnail,
            streaming_status: response.streaming_status,
            streaming_video: response.streaming_video,
            video: response.video
          };
          if (item.uploadType === 'exerciseVideos') {
            itemUpdate.video_orientation = response.video_orientation;
          }
          dispatch(pollingComplete({
            ...item,
            ...itemUpdate,
          }));
          clearInterval(intervalId);
          const { setId, videoBefore, ...others } = {
            ...item,
            ...itemUpdate,
          }
          if (item.uploadType === 'welcomeVideo') {
            apiService.uploadWelcomeVideo({ ...item, ...itemUpdate, id: item.videoId });
            itemUpdate.video_orientation = response.video_orientation;
            dispatch(getUpdatedWelcomeVideo({
              ...item,
              ...itemUpdate,
              id: item.videoId,
            }));
          } else {
            dispatch(updateSetsVideo({
              id: item.videoId,
              videoBefore,
              videoData: others,
            }));
          }
          clearInterval(intervalId);
          return { ...item, itemUpdate };
        }
        else if (Date.now() - startTime >= POLLING_TIMEOUT) {

          let updateMethod;
          switch (item.uploadType) {
            case UploadType.EXERCISE_VIDEOS:
              updateMethod = 'updateExerciseVideo';
              break;
            case UploadType.OVERVIEW_VIDEOS:
              updateMethod = 'updateOverviewVideo';
              break;
            case UploadType.WELCOME_VIDEO:
              updateMethod = 'updateWelcomeVideo';
              break;
            default:
              return;
          }

          apiService[updateMethod](item.videoId, {
            streaming_status: STREAMING_STATUS.TIMEOUT,
          });
          dispatch(pollingTimeout(item));
          clearInterval(intervalId);
        }
      });
  }, POLLING_INTERVAL);
}

export const startAudioPolling = (item) => (dispatch) => {
  dispatch(addToQueue(item));
  const startTime = +new Date();
  const intervalId = setInterval(() => {
    apiService.getOverviewAudio(item.audioId)
      .then(response => {
        // if this id is complete, dispatch pollingComplete for the item
        if (response.streaming_status === STREAMING_STATUS.COMPLETE) {
          const itemUpdate = {
            streaming_status: response.streaming_status,
            streaming_audio: response.streaming_audio,
          };
          dispatch(pollingComplete({
            ...item,
            ...itemUpdate,
          }));
          clearInterval(intervalId);
        }
        else if (Date.now() - startTime >= POLLING_TIMEOUT) {
          apiService.updateOverviewAudio(item.audioId, {
            streaming_status: STREAMING_STATUS.TIMEOUT,
          });
          dispatch(pollingTimeout(item));
          clearInterval(intervalId);
        }
      });
  }, POLLING_INTERVAL);
}
